import z from 'zod';

export const signInSearchSchema = z.object({
    returnUrl: z.url().optional(),
});
